import { combineReducers } from '@reduxjs/toolkit';

import mxAssembly from 'mx_pcb_assembly/store/slice';

const rootReducer = combineReducers({
  mxAssembly,
});

export default rootReducer;
